import { SubscriptionSettings } from '@/components/settings/SubscriptionSettings';
import { MainLayout } from '@/components/layout/MainLayout';
import { CreditCard } from 'lucide-react';

export default function Subscription() {
  return (
    <MainLayout>
      <div className="space-y-6">
        <div className="flex items-center gap-2">
          <CreditCard className="h-6 w-6 text-hospital-primary" />
          <h1 className="text-2xl font-bold">Subscription & Plans</h1>
        </div>
        <SubscriptionSettings />
      </div>
    </MainLayout>
  );
}
